/** Additional admin help topics — BT-028-R2 (EN). */

export const helpTopicsAdminEn028R2 = {
  "admin-classes": {
    key: "admin-classes",
    screenLabel: "Classes / courses",
    purpose: "Manage weekly schedule — demo data, official hours pending.",
    actions: ["Browse and filter classes.", "Add or edit a demo session.", "Verify dojo and assigned instructor."],
    warning: "[DEMO] — official schedule pending client file.",
    nextStep: "Check events or light attendance.",
  },
  "admin-events": {
    key: "admin-events",
    screenLabel: "Events",
    purpose: "Dojo event calendar — Phase 1 demo.",
    actions: ["Search an event.", "Filter by type or period.", "View demo details."],
    warning: "[DEMO] — no operational registrations in Phase 1.",
    nextStep: "Check Sensei space for the same events.",
  },
  "admin-attendance": {
    key: "admin-attendance",
    screenLabel: "Attendance",
    purpose: "Light attendance — limited demo view and entry.",
    actions: ["Filter by class or date.", "Review recorded attendance."],
    warning: "Operational attendance is out of Phase 1 scope — demo data only.",
    nextStep: "Return to classes for schedule context.",
  },
  "admin-progression": {
    key: "admin-progression",
    screenLabel: "Progress / belts / exams",
    purpose: "Progress tracking, belt reference and exams — demo.",
    actions: ["Review student progress.", "Shotokan belt reference.", "Exams — Phase 1 placeholder."],
    warning: "[DEMO] — no official grade validation.",
    nextStep: "Check Shotokan for titles and recognitions.",
  },
  "admin-accounts": {
    key: "admin-accounts",
    screenLabel: "Accounts",
    purpose: "Staging accounts and entry of official emails supplied by Gilles — no invented emails.",
    actions: [
      "Review temporary staging accounts (.local).",
      "Replace a staging email with a confirmed official email.",
      "Force password change if needed.",
    ],
    warning: "No official email address must be invented — manual entry only.",
    nextStep: "Use Official List Preparation for the template sent to Gilles.",
  },
  "admin-official-list-prep": {
    key: "admin-official-list-prep",
    screenLabel: "Official List Preparation",
    purpose:
      "Collection template to receive Gilles's official list of people, emails, roles and dojos — bulk import not enabled.",
    actions: [
      "Download the CSV template (headers only).",
      "Review required fields and allowed values.",
      "After receiving Gilles's file, enter emails in Accounts & Access.",
    ],
    warning: "No official data must be invented. Bulk import is not enabled.",
    nextStep: "Open Accounts & Access to enter confirmed official emails.",
  },
  "admin-roles": {
    key: "admin-roles",
    screenLabel: "Roles",
    purpose: "DojoOS / MartialCore role matrix — Phase 1 reference.",
    actions: ["Review available roles.", "Compare Hanshi, Sensei, Sempai, Parent, Student rights."],
    warning: "Demo reference — no server RBAC in Phase 1.",
    nextStep: "Return to Accounts to test a role.",
  },
  "admin-requests": {
    key: "admin-requests",
    screenLabel: "Account requests",
    purpose: "Locally submitted requests — no automatic approval.",
    actions: ["Filter by status.", "Review a request.", "Mark handled (demo)."],
    warning: "[DEMO] — no real account creation.",
    nextStep: "Use a demo account to test immediately.",
  },
  "admin-communications": {
    key: "admin-communications",
    screenLabel: "Communications",
    purpose: "Communications module — DojoOS Phase 1 placeholder.",
    actions: ["Review module structure.", "Note demo scope."],
    warning: "Real sending is out of Phase 1 — placeholder only.",
    nextStep: "Check Parent space for allowed communications.",
  },
  "admin-diagnostic-avatar": {
    key: "admin-diagnostic-avatar",
    screenLabel: "Avatar diagnostic",
    purpose: "Authoritatively verify photo persistence (disk, DB, /auth/me, instructors).",
    actions: [
      "Click “Verify my avatar” after an upload.",
      "Confirm PASS before Ctrl+F5.",
      "Use “Repair from disk” if file exists but DB is empty.",
    ],
    checklist: [
      "POST /api/v1/avatars/profile = 200",
      "GET avatar image = 200",
      "/auth/me includes avatar_url",
      "Instructor card uses backend in hybrid staging",
    ],
    mistakes: [
      "Trusting a temporary blob preview without diagnostic PASS.",
      "Re-running db:seed without checking avatar preservation.",
    ],
    nextStep: "Upload a photo, validate PASS, then Ctrl+F5 on header and /instructeurs.",
  },
};
